import React from "react"
import { Modal } from "react-bootstrap"
import { CreatePOModalProps } from "../../common/types/order"
import IntlProps from "../../state/helpers/IntlProps"
import { CREATE_PO_MODAL_MESSAGES } from "../../utils/order"
import { CancelButton } from "../../common/button"
import { injectIntl } from "react-intl"
import CustomerSelect from "../../customer/selection.component"
import StandardList from "../../common/listing/list.component"
import { CREATE_PO_MODAL_HEADERS } from "../../utils/order"
import { STOCK_DOCUMENTS } from "../../utils/inventory"
import Checkbox from "../../common/checkbox/checkbox.component"
import ActionButton from "../../common/button/actionbutton.component"
import { useDispatch } from "react-redux"
import { StockDocumentAction } from "../../state/inventory/stockdocument/actions"
import { ORDER_LINES, ORDERS } from "../../state/order/Constants"

export const CreatePOModal = injectIntl((props: CreatePOModalProps & IntlProps) => {
    const [contactId, setContactId] = React.useState<string>("")
    const [selectedIds, setSelectedIds] = React.useState<Array<string>>([])
    const [loading, setLoading] = React.useState<boolean>(false)
    const dispatch = useDispatch()

    const selectableIds = props.items
        .filter(item => !item.attributes.references?.find(ref => ref.attributes.referenceKey === STOCK_DOCUMENTS))
        .map(item => item.id)

    const rows = props.items.map(item => {
        const attributes = item.attributes
        const ref = attributes.references?.find(ref => ref.attributes.referenceKey === STOCK_DOCUMENTS)
        const supplierName = attributes.itemObject.attributes.supplierCosts.find(
            supplier => supplier.attributes.isDefault)?.attributes.supplierName ?? ""

        return [
            attributes.activeTitle,
            attributes.inventoryRequestedMeasure,
            ref ? attributes.inventoryRequestedMeasure : attributes.inventoryReceivedMeasure,
            ref ? "0" : attributes.inventoryRequestedMeasure,
            supplierName,
            selectableIds.indexOf(item.id) != -1 ? (
                <Checkbox
                    key={0}
                    disabled={loading}
                    checked={selectedIds.includes(item.id)}
                    onChange={() => setSelectedIds(current =>
                        current.find(i => item.id === i) ?
                            current.filter((i) => i !== item.id)
                            : [...current, item.id]
                    )}
                />
            ) : null
        ]
    })

    const headers = CREATE_PO_MODAL_HEADERS.concat(
        <Checkbox
            key={0}
            disabled={loading}
            checked={selectedIds.length === selectableIds.length}
            onChange={() => {
                setSelectedIds(
                    current => current.length === selectableIds.length ?
                        [] : selectableIds.map(item => item))
            }}
        />
    )

    const onCreate = () => {
        setLoading(true)
        dispatch(StockDocumentAction.createFromReference({
            contactId: contactId,
            locationId: props.locationId,
            referenceKey: ORDERS,
            referenceId: props.documentId,
            referenceIdentifier: props.documentIdentifier,
            referenceProjectId: props.documentProjectId,
            rows: selectedIds.map(id => {
                const item = props.items.find(item => item.id === id)

                return {
                    productId: item?.attributes.itemObject?.id || "",
                    measure: item?.attributes.inventoryRequestedMeasure || "0",
                    supplierId: contactId,
                    references: [
                        {
                            referenceKey: ORDER_LINES,
                            referenceId: id,
                            referenceIdentifier: props.documentIdentifier
                        },
                        {
                            referenceKey: ORDERS,
                            referenceId: props.documentId,
                            referenceIdentifier: props.documentIdentifier
                        }
                    ]
                }
            }),
        }))
    }

    const onClose = () => {
        if (!loading) {
            props.onCloseCallback()
        }
    }

    const disableCreateButton = selectedIds.length === 0 || contactId === ""
    return (
        <Modal
            className={"custom-modal"}
            show={true}
            onHide={onClose}
            size={"lg"}
            backdrop={"static"}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {props.intl.formatMessage(CREATE_PO_MODAL_MESSAGES.header)}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className={"d-flex align-items-center pl-2"}>
                    <label>{props.intl.formatMessage(CREATE_PO_MODAL_MESSAGES.supplierSelectLabel)}</label>
                    <CustomerSelect
                        contactType={"suppliers"}
                        placeholder={CREATE_PO_MODAL_MESSAGES.supplierSelectPlaceholder}
                        className={"col-4"}
                        disabled={loading}
                        value={contactId}
                        defaultSelectedOptions={null}
                        onChange={setContactId}
                        clearable={false}
                    />
                </div>

                <StandardList
                    headers={headers}
                    rows={rows}
                />
            </Modal.Body>

            <Modal.Footer>
                <CancelButton onClickCallback={onClose} disabled={loading}/>
                <ActionButton className={"btn btn-primary"} onClick={onCreate} disabled={disableCreateButton}>
                    {props.intl.formatMessage(CREATE_PO_MODAL_MESSAGES.createButtonLabel)}
                </ActionButton>
            </Modal.Footer>
        </Modal>
    )
})


// WEBPACK FOOTER //
// ./src/order/modals/CreatePOModal.tsx